/**
 * Represents a picklist option for a model value
 */
export class ValueOption {
  /**
 * The unique identifier for the option.
 */
  id?: string | null;

  /**
   * The identifier of the related model value.
   */
  modelValueId?: string | null;
  
  /**
   * The code associated with the option.
   */
  code?: string | null;

  /**
   * Optional. The display value for the option.
   * 
   * Note: if we are using tagId as a foreign key to a lookup table
   * then this value being set cannot be relied upon to be accurate!
   */
  val?: string | null;

  /**
   * The external tag identifier associated with the option.
   * Foreign key to a lookup table
   */
  tagId?: string | null;

  /**
   * The sort order of the question option.
   */
  sortOrder?: number | null;

  /**
   * If the option is still valid
   */
  isActive?: boolean | null;

  /**
   * Filter the list of value options by an array of string values
   * @param options
   * @param allowedValues
   * @returns
   */
  public static filterOptionsByValues(options: ValueOption[], allowedValues: string[]): ValueOption[] {

    if (!options || !allowedValues || allowedValues.length === 0) {
      return options || [];
    }

    const filtered = options.filter(option =>
      option.val && allowedValues.includes(option.val)
    );

    return filtered;
  }

}
